import { render, staticRenderFns } from "./donot.vue?vue&type=template&id=bffa1750&"
import script from "./donot.vue?vue&type=script&lang=js&"
export * from "./donot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports